import Axios from 'axios';
import React, { useEffect } from 'react';
import { useRouter } from 'next/router';

import SocialAuth from '@strongio/pretrained-dashboard/views/logistration/SocialAuth';

export default function SocialLogin({ authComplete }) {
  const router = useRouter();

  useEffect(() => {
    if (router.query.utm_source && router.query.utm_source.toLowerCase() === 'sso') {
      Axios.post('/api/sso/token').
      then((response) => authComplete(response.data)).
      catch(() => false);
    }
  }, [authComplete, router]);

  return /*#__PURE__*/React.createElement(SocialAuth, null);
}